import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { Grid, Icon, IconButton, InputBase, Paper, Typography } from '@mui/material'
import { createLightColor } from 'utils/ColorUtil'

const InputLogin = ({
    label,
    iconLabel,
    passwordInput,
    value,
    onChange,
    onEnterKeyPress,
    required,
    maxLength,
    'data-cy': dataCy,
}) => {
    const [showText, setShowText] = useState(!passwordInput)
    return (
        <Grid>
            <Grid container alignItems='center' spacing={2} sx={{ padding: '10px 10px 10px 15px' }}>
                {iconLabel && <Icon sx={{ color: createLightColor('grey') }}>{iconLabel}</Icon> }
                <Typography variant='span' color={createLightColor('grey')}>{label}{required && '*'}</Typography>
            </Grid>
            <Paper sx={{ display: 'flex', alignItems: 'center', margin: '5px 0' }}>
                <InputBase
                    type={showText ? 'text' : 'password'}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyUp={(event) => {
                        if (event.key == 'Enter') {
                            onEnterKeyPress()
                        }
                    }}
                    maxLength={maxLength}
                    data-cy={dataCy}
                    sx={{
                        width: '100%',
                        boxShadow: 'none',
                        '& input[type=text]:not(.browser-default)': {
                            border: 'none',
                            boxShadow: 'none',
                            width: '100%',
                            margin: 0,
                        },
                        '& input[type=password]:not(.browser-default)': {
                            border: 'none',
                            boxShadow: 'none',
                            width: '100%',
                            margin: 0,
                        },
                        '& input[type=text]:not(.browser-default):focus:not([readonly])': {
                            border: 'none',
                            boxShadow: 'none',
                        },
                        '& input[type=password]:not(.browser-default):focus:not([readonly])': {
                            border: 'none',
                            boxShadow: 'none',
                        },
                    }}
                />
                {passwordInput && (
                    <IconButton
                        type='button'
                        sx={{ p: '10px' }}
                        aria-label='search'
                        onClick={() => setShowText(!showText)}
                    >
                        {showText ? <VisibilityOff fontSize='large' sx={{ color: 'black' }} /> : <Visibility fontSize='large' sx={{ color: 'black' }} />}
                    </IconButton>
                )}
            </Paper>
        </Grid>
    )
}

InputLogin.propTypes = {
    label: PropTypes.string,
    iconLabel: PropTypes.string,
    passwordInput: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onEnterKeyPress: PropTypes.func,
    required: PropTypes.bool,
    maxLength: PropTypes.number,
    'data-cy': PropTypes.string,
}

export default InputLogin